import { IAPIRoutes } from "../../../../config";

/**
 * NP Productivity Timeline repository.
 *
 * Auth headers are injected automatically by `apiProvider.getDefaultHeaders()`
 * for `/patient-centric-app-v2/...` routes — we deliberately do NOT pass an
 * `Authorization` header here (see cip-rules.mdc).
 */
export const NpProductivityTimelineRepositoryFactory = ({
  APIProvider,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  APIRoutes: IAPIRoutes;
}): INpProductivityTimelineRepository => {
  const { GET } = APIProvider;

  const getTimeline: INpProductivityTimelineRepository["getTimeline"] = (
    payload
  ) =>
    GET(APIRoutes.apiNpProductivityTimeline, {
      date: payload.date,
      tz: payload.tz,
      ...(payload.include_full_roster != null
        ? { include_full_roster: payload.include_full_roster }
        : {}),
    });

  const getWindowSummary: INpProductivityTimelineRepository["getWindowSummary"] =
    (payload) =>
      GET(APIRoutes.apiNpProductivityWindowSummary, {
        start: payload.start,
        end: payload.end,
        tz: payload.tz,
        ...(payload.np_ids ? { np_ids: payload.np_ids } : {}),
      });

  return {
    getTimeline,
    getWindowSummary,
  };
};
